import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

// services
import { PushNotificationService } from './data/services/push-notification.service';

// Quill option registry
import Quill from 'quill';
import MagicUrl from 'quill-magic-url';
import { ClarityService } from './data/services/clarity.service';
var StyleAlign = Quill.import('attributors/style/align');
Quill.register(StyleAlign, true);
Quill.register('modules/magicUrl', MagicUrl);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'agendaamais-web';

  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private readonly notificationService: PushNotificationService,
    private readonly clarityService: ClarityService
  ) {
    iconRegistry.addSvgIcon(
      'back-arrow',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/recipient_back_button.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'help-flag',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/Group_278.svg')
    );
    iconRegistry.addSvgIcon(
      'icon-doubt',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/BlueIconDoubts.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'custom-warning',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/warning.svg')
    );
    iconRegistry.addSvgIcon(
      'icon-schedule',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/icon-schedule.svg')
    );
    iconRegistry.addSvgIcon(
      'icon-closed',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/icon-closed.svg')
    );
  }

  ngOnInit(): void {
    this.clarityService.init();
    this.notificationService.requestFcmToken();
    this.notificationService.listenNotifications();
    this.notificationService.enableChatNotifications();
  }
}
